import fb from '../../firebaseConfig.js';
import { CATEGORIES, CURRENT_USER, SET_CATEGORIES } from '../constants';
import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    [CATEGORIES]: []
  },
  actions: {
    async getCategories({ commit, rootState }) {
      try {
        const items = [];
        let response = await fb.users
          .doc(rootState.auth[CURRENT_USER].uid)
          .collection('categories')
          .get();
        return response.docs.map(async d => {
          const res = await fb.users
            .doc(rootState.auth[CURRENT_USER].uid)
            .collection('categories/' + d.id + '/subcategories')
            .get();
          const subcategories = res.docs.map(d => d.data());
          const tmp = { id: d.id, ...d.data(), subcategories };
          items.push(tmp);
          commit(SET_CATEGORIES, items);
          return tmp;
        });
      } catch (error) {
        Vue.prototype.$notification.error({
          message: 'Ooops! Something went wrong while fetching categories.',
          description: error.message,
          placement: 'bottomLeft'
        });
        throw error;
      }
    },
    async updateCategories({ commit, state, rootState, dispatch }, categories) {
      try {
        const batch = fb.db.batch();
        batch.update(fb.users.doc(rootState.auth[CURRENT_USER].uid), {
          'hasConfigured.categories': true
        });
        const items = [];
        categories.forEach((category, categoryIndex) => {
          const t = { ...state.categories[categoryIndex] };
          t.subcategories = category.subcategories.map((subcategory, subcategoryIndex) => {
            const item = {
              id: subcategory.id,
              name: subcategory.name,
              icon: subcategory.icon,
              parentId: subcategory.parentId
            };
            if (
              subcategory.name !==
              state.categories[categoryIndex].subcategories[subcategoryIndex].name
            ) {
              batch.update(fb.users.doc(subcategory.id.replace('users/', '')), item);
            }
            return {
              id: subcategory.id,
              name: subcategory.name,
              icon: subcategory.icon,
              parentId: subcategory.parentId
            };
          });
          items.push(t);
        });
        await batch.commit();
        dispatch('auth/fetchUserProfile', null, { root: true });
        commit(SET_CATEGORIES, items);
        return batch;
      } catch (error) {
        Vue.prototype.$notification.error({
          message: 'Ooops! Something went wrong while saving categories.',
          description: error.message,
          placement: 'bottomLeft'
        });
        throw error;
      }
    }
  },
  mutations: {
    [SET_CATEGORIES]: (s, d) => (s[CATEGORIES] = d)
  }
};
